import { render, staticRenderFns } from "./FormTexto.vue?vue&type=template&id=89031752&scoped=true"
import script from "./FormTexto.vue?vue&type=script&lang=js"
export * from "./FormTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89031752",
  null
  
)

export default component.exports